import MoreVertIcon from "@mui/icons-material/MoreVert";
import { MRT_Cell } from "material-react-table";
import { useState } from "react";
import IwMenu from "../../../app/IwMenu";
import { TTeamUser } from "./TeamUserTable";
import { RemoveFromGroupModal } from "../../common/RemoveFromGroup.modal";
import { AddRoleModal } from "../../common/AddRoleModal";
import { MoveUserModal } from "../../common/MoveUserModal";
import { useNavigate } from "react-router-dom";

export const ActionCell = ({ cell }: { cell: MRT_Cell<TTeamUser, unknown> }) => {
  const [openRoleModal, setOpenRoleModal] = useState(false);
  const [openRemoveFromTeamModal, setOpenRemoveFromTeamModal] = useState(false);
  const [openMoveUserModal, setOpenMoveUserModal] = useState(false);

  const user = cell.row.original;
  const navigate = useNavigate();

  return (
    <>
      <AddRoleModal
        selectedUser={user}
        open={openRoleModal}
        handleClose={() => {
          setOpenRoleModal(false);
        }}
      />

      <RemoveFromGroupModal
        open={openRemoveFromTeamModal}
        handleClose={() => {
          setOpenRemoveFromTeamModal(false);
        }}
        cohortTypeLabel="Team"
        roleID={cell?.row?.original?.roleID}
      />

      <MoveUserModal
        data={{ name: user?.name, userName: user?.username }}
        open={openMoveUserModal}
        handleClose={() => {
          setOpenMoveUserModal(false);
        }}
        source="Team"
        currentRoleID={cell?.row?.original?.roleID}
      />

      <IwMenu
        label={<MoreVertIcon fontSize="small" />}
        tooltipProps={{
          title: "Options"
        }}
        triggerComponentSx={{
          margin: "0 8px",
          padding: "2px 0"
        }}
        items={[
          {
            id: "add-role",
            label: "Add Roles",
            onClick: () => {
              setOpenRoleModal(true);
            }
          },
          {
            id: "go-to-details",
            label: "Go to Details",
            onClick: () => {
              navigate(`/admin/${user?.userID}`, {
                state: { userData: user },
              })
            }
          },
          {
            id: "move-user",
            label: "Move User",
            onClick: () => {
              setOpenMoveUserModal(true);
            }
          },
          {
            id: "remove-from-team",
            label: "Remove from Team",
            onClick: () => {
              setOpenRemoveFromTeamModal(true);
            }
          }
        ]}
      />
    </>
  );
};
